import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { View } from '@olxbr/design-system'

import behaviors from '../../../util/behaviors'
import Lurker from '../../../util/lurker'
import { GenericErrorBox } from '../../molecules/GenericErrorBox'
import forgotPasswordApiCall from '../../../api/forgotPasswordApiCall'

import EmailFormBaseTemplate from '../EmailFormBaseTemplate'

const lurker = new Lurker('forgot_password')

const ErrorMsgWrapper = styled(View)`
  margin-top: 16px;
  margin-right: 0;
  margin-bottom: 16px;
  margin-left: 0;
`

class ForgotPasswordTemplate extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      abTests: this.props.abTests || '',
      showGenericError: false,
      showRateLimitError: false,
      unregisteredEmail: false,
      showInactiveError: false,
    }
  }

  componentDidMount() {
    lurker.pageLoadEvt()
  }

  onSubmit = (email, recaptchaToken) => {
    const { abTests } = this.state

    this.setState({
      showGenericError: false,
      showRateLimitError: false,
      unregisteredEmail: false,
      showInactiveError: false,
    })

    return forgotPasswordApiCall(email, abTests, recaptchaToken)
      .then(data => {
        lurker.viewMessageEvt('success')
        if (this.props.onSuccess) {
          this.props.onSuccess(data, email)
          this.setState({
            showGenericError: false,
            showRateLimitError: false,
            unregisteredEmail: false,
            showInactiveError: false,
          })
        }
      })
      .catch((data = {}) => {
        const {
          response: { status, data: { message } = {} } = {},
          message: exceptionMessage = 'unknown',
        } = data

        behaviors.scrollToTop()

        if (status === 404) return this.handle404()
        if (status === 429) return this.handle429()
        if (status === 410) return this.handle410()
        if (status) return this.handleUnexpectedStatusCode(status, message)
        return this.handleUnexpectedError(exceptionMessage)
      })
  }

  handle410 = () => {
    lurker.viewMessageEvt('error', {
      accounts_reason: 'account_inactive',
      accounts_status_code: 410,
    })
    this.setState({ showInactiveError: true })
  }

  handle429 = () => {
    lurker.viewMessageEvt('error', {
      accounts_reason: 'rate_limit_exceeded',
      accounts_status_code: 429,
    })
    this.setState({ showRateLimitError: true })
  }

  handle404 = () => {
    lurker.viewMessageEvt('error', {
      accounts_reason: 'unregistered_account',
      accounts_status_code: 404,
    })
    this.setState({
      unregisteredEmail: true,
    })
  }

  handleUnexpectedStatusCode = (status, message = 'unexpected_status_code') => {
    lurker.viewMessageEvt('error', {
      accounts_reason: message.toLowerCase(),
      accounts_status_code: status,
    })
    this.setState({ showGenericError: true })
  }

  handleUnexpectedError = (message = 'unknown') => {
    lurker.viewMessageEvt('error', {
      accounts_reason: 'unexpected_error',
      accounts_error_message: message,
    })
    this.setState({ showGenericError: true })
  }

  renderError = () => {
    const { onRegisterClick, showAccountNotFoundTest } = this.props
    const { showRateLimitError, showGenericError, unregisteredEmail, showInactiveError } =
      this.state
    return (
      <React.Fragment>
        {unregisteredEmail && showAccountNotFoundTest && (
          <ErrorMsgWrapper>
            <GenericErrorBox
              showAccountNotFoundError
              errorAction={onRegisterClick}
              text="Não existe uma conta com este e-mail."
            />
          </ErrorMsgWrapper>
        )}
        {showGenericError && (
          <ErrorMsgWrapper>
            <GenericErrorBox text="Não foi possível solicitar a recuperação de senha." />
          </ErrorMsgWrapper>
        )}
        {showInactiveError && (
          <ErrorMsgWrapper>
            <GenericErrorBox
              showContactUs
              contactUsLink="https://ajuda.olx.com.br/s/article/reativar-conta-na-olx"
              text="Este e-mail não pode mais ser usado."
            />
          </ErrorMsgWrapper>
        )}
        {showRateLimitError && (
          <ErrorMsgWrapper>
            <GenericErrorBox
              showContactUs={false}
              text="Você excedeu o número de tentativas. Por favor, tente novamente mais tarde."
            />
          </ErrorMsgWrapper>
        )}
      </React.Fragment>
    )
  }

  render() {
    const { unregisteredEmail } = this.state
    const { showAccountNotFoundTest } = this.props

    return (
      <EmailFormBaseTemplate
        buttonText="Receber instruções"
        fieldError={!showAccountNotFoundTest && 'Este e-mail não possui uma conta na OLX'}
        hasError={unregisteredEmail}
        lurker={lurker}
        onSubmit={this.onSubmit}
        renderError={this.renderError}
        renderTitle="Enviaremos instruções para o seu e-mail, assim garantimos que apenas você pode redefinir a senha."
      />
    )
  }
}

ForgotPasswordTemplate.propTypes = {
  onSuccess: PropTypes.func,
  onRegisterClick: PropTypes.func,
  showAccountNotFoundTest: PropTypes.bool,
  abTests: PropTypes.string,
}

export default ForgotPasswordTemplate
